import { DeleteFacesFeature } from '@kb3d/models/classes/features/delete-faces-feature';
import { FeatureGeometryProcessor, ProcessorData } from './base-processor';
import { ITrackedClass } from '@kb3d/models/interfaces/tracked-class';
import { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';

export class DeleteFacesGeometryProcessor extends FeatureGeometryProcessor<DeleteFacesFeature> {
    updateMeshGeometry(
        feature: ITrackedClass<DeleteFacesFeature>,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>,
        dependencyData: ProcessorData<never>
    ) {
        const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges, dependencyData);

        if (newVertexData.indices && feature.vertexGroups.length > 0) {
            const vertexGroups = feature.vertexGroups.sort((groupA, groupB) => groupA.startIndex - groupB.startIndex);
            const newIndices = new Int32Array(newVertexData.indices);
            let currReadIndex = 0;

            vertexGroups.forEach(vertexGroup => {
                for (
                    let i = Math.max(vertexGroup.startIndex, currReadIndex);
                    i < Math.min(vertexGroup.endIndex, newIndices.length);
                    i++
                ) {
                    newIndices[i] = -1;
                }
                currReadIndex = vertexGroup.endIndex;
            });

            // We need to remove submeshes targetting the indices that are being removed as well
            if (newVertexData.submeshData) {
                newVertexData.submeshData.forEach(submeshData => {
                    const indexStart = submeshData.indexStart;
                    for (let i = 0; i < indexStart; i++) {
                        if (newIndices[i] === -1) {
                            submeshData.indexStart--;
                        }
                    }
                    const indexCount = submeshData.indexCount;
                    for (let i = 0; i < indexCount; i++) {
                        const index = indexStart + i;
                        if (newIndices[index] === -1) {
                            submeshData.indexCount--;
                        }
                    }
                });
            }

            newVertexData.indices = newIndices.filter(index => index !== -1);
        }
        return newVertexData;
    }
}
